/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Input_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Use the upload button in the toolbar to attach files just for this conversation. For files the whole project should reuse, add them to a space instead and @-..." |
*
* @param {Uno_Edu_Chat_Input_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_input_chip2_answer = /** @type {((inputs?: Uno_Edu_Chat_Input_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Input_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie die Upload-Schaltfläche in der Symbolleiste, um Dateien nur für diese Konversation anzuhängen. Für Dateien, die das gesamte Projekt wiederverwenden soll, fügen Sie sie stattdessen einem Space hinzu und erwähnen ihn mit @.")
	return /** @type {LocalizedString} */ ("Use the upload button in the toolbar to attach files just for this conversation. For files the whole project should reuse, add them to a space instead and @-mention it.")
});